import * as i2 from '@abp/ng.core';
import { ConfigStateService, EnvironmentService, WebHttpUrlEncodingCodec, setTokenResponseToStorage, noop, CoreModule, mapEnumToOptions, ExtensibleCreationAuditedEntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';
import * as i0 from '@angular/core';
import { Injectable, APP_INITIALIZER, Component, InjectionToken, NgModule, inject } from '@angular/core';
import * as i4 from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NavItemsService } from '@abp/ng.theme.shared';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { tap, map, filter, switchMap } from 'rxjs/operators';
import * as i3 from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { __rest } from 'tslib';

const grantType = 'Impersonation';
class ImpersonationService {
    constructor(injector) {
        this.injector = injector;
        this.oAuthService = injector.get(OAuthService);
        this.configState = injector.get(ConfigStateService);
        this.environment = injector.get(EnvironmentService);
        this.http = injector.get(HttpClient);
        const navItems = injector.get(NavItemsService);
        navItems.addItems([
            {
                id: "CommercialUi.BackToImpersonationNavItem" /* BackToImpersonationNavItem */,
                order: 99,
                component: BackToImpersonatorNavItemComponent,
            },
        ]);
    }
    get params() {
        const { clientId, dummyClientSecret } = this.oAuthService;
        return new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
            .set('access_token', this.oAuthService.getAccessToken())
            .set('grant_type', grantType)
            .set('Client_Id', clientId)
            .set('Client_Secret', dummyClientSecret);
    }
    get tokenEndpoint() {
        return this.oAuthService.tokenEndpoint;
    }
    impersonateTenant(tenantId) {
        return this.impersonate({ tenantId });
    }
    impersonateUser(userId) {
        const { currentTenant } = this.configState.getAll();
        return this.impersonate({ userId, tenantId: currentTenant.id });
    }
    impersonate({ tenantId, userId }) {
        let params = this.params;
        if (tenantId) {
            params = params.set('TenantId', tenantId);
        }
        if (userId) {
            params = params.set('UserId', userId);
        }
        return this.http.post(this.tokenEndpoint, params).pipe(tap((res) => setTokenResponseToStorage(this.injector, res)), tap(() => {
            var _a;
            const redirectUrl = ((_a = this.environment.getEnvironment().application) === null || _a === void 0 ? void 0 : _a.baseUrl) || '/';
            location.href = redirectUrl;
        }));
    }
}
ImpersonationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: ImpersonationService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
ImpersonationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: ImpersonationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: ImpersonationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });
const IMPERSONATION_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        multi: true,
        deps: [ImpersonationService],
        useFactory: noop,
    },
];

class BackToImpersonatorNavItemComponent {
    constructor(impersonation, configState, environment) {
        this.impersonation = impersonation;
        this.configState = configState;
        this.environment = environment;
    }
    get impersonatorVisible() {
        const { currentUser: { impersonatorUserId: userId }, } = this.configState.getAll();
        return !!userId;
    }
    backToImpersonator() {
        this.impersonation.impersonate({}).subscribe();
    }
}
BackToImpersonatorNavItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: BackToImpersonatorNavItemComponent, deps: [{ token: ImpersonationService }, { token: i2.ConfigStateService }, { token: i2.EnvironmentService }], target: i0.ɵɵFactoryTarget.Component });
BackToImpersonatorNavItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.1", type: BackToImpersonatorNavItemComponent, selector: "abp-back-to-impersonator-nav-item", ngImport: i0, template: `
    <button
      *ngIf="impersonatorVisible"
      (click)="backToImpersonator()"
      class="btn text-danger"
      [ngbTooltip]="'AbpAccount::BackToImpersonator' | abpLocalization"
      placement="left"
    >
      <i class="fa fa-undo"></i>
    </button>
  `, isInline: true, directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "abpLocalization": i2.LocalizationPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: BackToImpersonatorNavItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'abp-back-to-impersonator-nav-item',
                    template: `
    <button
      *ngIf="impersonatorVisible"
      (click)="backToImpersonator()"
      class="btn text-danger"
      [ngbTooltip]="'AbpAccount::BackToImpersonator' | abpLocalization"
      placement="left"
    >
      <i class="fa fa-undo"></i>
    </button>
  `,
                }]
        }], ctorParameters: function () { return [{ type: ImpersonationService }, { type: i2.ConfigStateService }, { type: i2.EnvironmentService }]; } });

const DEFAULT_PROFILE_ICON = {
    type: 'icon',
    source: 'fas fa-user bg-light',
};

const PROFILE_PICTURE = new InjectionToken('PROFILE_PICTURE', {
    providedIn: 'root',
    factory: () => new BehaviorSubject({ type: 'image', source: null }),
});

class ProfilePictureService {
    constructor(restService, injector, configState) {
        this.restService = restService;
        this.injector = injector;
        this.configState = configState;
        this.url = '/api/account-admin/settings';
        this.publicApiName = 'AbpAccountPublic';
        this.getProfilePicture = (id, skipHandleError = false) => this.restService.request({
            method: 'GET',
            url: `/api/account/profile-picture/${id}`,
        }, {
            apiName: this.publicApiName,
            skipHandleError,
        });
        this.setProfilePicture = (input) => {
            const form = new FormData();
            form.append('type', input.type + '');
            if (input.imageContent) {
                form.append('ImageContent', input.imageContent);
            }
            return this.restService.request({
                method: 'POST',
                url: `/api/account/profile-picture`,
                body: form,
            }, { apiName: this.publicApiName });
        };
        this.listenToAppConfig();
    }
    listenToAppConfig() {
        const profilePicture$ = this.injector.get(PROFILE_PICTURE);
        this.configState
            .createOnUpdateStream(state => state)
            .pipe(map(() => this.configState.getDeep('currentUser.id')), filter(id => id !== this.currentUserId), tap(id => {
            this.currentUserId = id;
            if (!id) {
                profilePicture$.next(null);
            }
        }), filter(id => !!id), switchMap(id => this.getProfilePicture(id, true)))
            .subscribe(res => {
            profilePicture$.next({
                type: 'image',
                source: res.source || `data:image/png;base64,${res.fileContent}`,
            });
        }, () => {
            profilePicture$.next(DEFAULT_PROFILE_ICON);
        });
    }
}
ProfilePictureService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: ProfilePictureService, deps: [{ token: i2.RestService }, { token: i0.Injector }, { token: i2.ConfigStateService }], target: i0.ɵɵFactoryTarget.Injectable });
ProfilePictureService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: ProfilePictureService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: ProfilePictureService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i2.RestService }, { type: i0.Injector }, { type: i2.ConfigStateService }]; } });

const PROFILE_PICTURE_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        multi: true,
        deps: [ProfilePictureService],
        useFactory: noop,
    },
];

class CommercialUiConfigModule {
    static forRoot() {
        return {
            ngModule: CommercialUiConfigModule,
            providers: [PROFILE_PICTURE_PROVIDERS, IMPERSONATION_PROVIDERS],
        };
    }
}
CommercialUiConfigModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CommercialUiConfigModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CommercialUiConfigModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CommercialUiConfigModule, declarations: [BackToImpersonatorNavItemComponent], imports: [CoreModule, NgbTooltipModule], exports: [BackToImpersonatorNavItemComponent] });
CommercialUiConfigModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CommercialUiConfigModule, imports: [[CoreModule, NgbTooltipModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CommercialUiConfigModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CoreModule, NgbTooltipModule],
                    exports: [BackToImpersonatorNavItemComponent],
                    declarations: [BackToImpersonatorNavItemComponent],
                }]
        }] });

var eProfilePictureType;
(function (eProfilePictureType) {
    eProfilePictureType[eProfilePictureType["None"] = 0] = "None";
    eProfilePictureType[eProfilePictureType["Gravatar"] = 1] = "Gravatar";
    eProfilePictureType[eProfilePictureType["Image"] = 2] = "Image";
})(eProfilePictureType || (eProfilePictureType = {}));
const profilePictureTypeOptions = mapEnumToOptions(eProfilePictureType);

class IdentitySecurityLogDto extends ExtensibleCreationAuditedEntityDto {
    constructor(initialValues = {}) {
        super(initialValues);
    }
}
class IdentitySecurityLogGetListInput extends PagedAndSortedResultRequestDto {
}

const NAVIGATE_TO_MY_SECURITY_LOGS = new InjectionToken('NAVIGATE_TO_MY_SECURITY_LOGS', {
    providedIn: 'root',
    factory: () => {
        const environment = inject(EnvironmentService);
        return () => {
            window.open(`${environment.getEnvironment().oAuthConfig.issuer}/Account/SecurityLogs?returnUrl=${window.location.href}`, '_self');
        };
    },
});

const OPEN_MY_LINK_USERS_MODAL = new InjectionToken('OPEN_MY_LINK_USERS_MODAL');

function setModuleVisibilityFactory(stream, service, identifier) {
    return stream.pipe(map(features => features.enable), tap(enable => {
        const _a = service.find(r => r.name === identifier), { children } = _a, tree = __rest(_a, ["children"]);
        tree.invisible = !enable;
        service.patch(identifier, tree);
    }));
}

/**
 * Generated bundle index. Do not edit.
 */

export { BackToImpersonatorNavItemComponent, CommercialUiConfigModule, DEFAULT_PROFILE_ICON, IMPERSONATION_PROVIDERS, IdentitySecurityLogDto, IdentitySecurityLogGetListInput, ImpersonationService, NAVIGATE_TO_MY_SECURITY_LOGS, OPEN_MY_LINK_USERS_MODAL, PROFILE_PICTURE, PROFILE_PICTURE_PROVIDERS, ProfilePictureService, eProfilePictureType, profilePictureTypeOptions, setModuleVisibilityFactory };
